import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function ServicesSuccessPage() {
    const services = [
        {
            title: "Expert Hosting & Infrastructure Management",
            description: "We provide enterprise-grade hosting solutions designed for stability and speed. Our managed infrastructure handles the technical complexities so you can focus on building your business.",
            features: ["High-Availability Cloud Servers", "24/7 Monitoring & Security", "Automated Backups", "Global CDN Integration"],
            image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=1000",
        },
        {
            title: "Full Web Application Development",
            description: "From initial architecture to front-end excellence, we build robust, scalable web applications using modern technology stacks. Our development process is focused on performance and user experience.",
            features: ["Custom SaaS Platforms", "Scalable Backend Architectures", "Modern Frontend Frameworks", "API Development & Integration"],
            image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&q=80&w=1000",
        },
        {
            title: "Rapid Technical Trouble-shooting",
            description: "Facing critical bugs or performance bottlenecks? Our specialized team audits and resolves complex web development problems with precision and speed.",
            features: ["Security Vulnerability Audits", "Database Optimization", "Legacy Code Modernization", "Frontend Performance Tuning"],
            image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&q=80&w=1000",
        },
        {
            title: "Scalable DevOps & Easy Deployment",
            description: "We implement zero-downtime CI/CD pipelines that automate your shipping process. Deploy with confidence, frequency, and ease.",
            features: ["Automated CI/CD Pipelines", "Docker & Kubernetes Orchestration", "Zero-Downtime Deployments", "Infrastructure as Code (IaC)"],
            image: "https://images.unsplash.com/photo-1607799279861-4dd421887fb3?auto=format&fit=crop&q=80&w=1000",
        }
    ];

    return (
        <div className="min-h-screen bg-gray-100 p-3 md:p-4">
            <div className="mx-auto bg-white rounded-[24px] md:rounded-[32px] shadow-xl overflow-hidden">
                <div className="bg-gradient-to-b from-[#0054DB] to-[#4284ED] pb-20 px-6 text-center rounded-[24px] md:rounded-[32px] overflow-hidden">
                    <Header isLoaded={true} />
                    <div className="max-w-4xl mx-auto mt-12 md:mt-24 text-white">
                        <h1 className="text-5xl md:text-7xl font-bold mb-6">Expertise Driven by Results</h1>
                        <p className="text-xl md:text-2xl opacity-90 max-w-2xl mx-auto leading-relaxed">
                            With over 10+ successful client partnerships, we manage and optimize every layer of your digital presence.
                        </p>
                    </div>
                </div>

                <div className="py-24 px-6 lg:px-20 max-w-7xl mx-auto">
                    <div className="grid gap-24">
                        {services.map((service, index) => (
                            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}>
                                <div className="flex-1 space-y-6">
                                    <h2 className="text-4xl font-bold text-gray-900">{service.title}</h2>
                                    <p className="text-xl text-gray-500 leading-relaxed italic">{service.description}</p>
                                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {service.features.map((feature, fIndex) => (
                                            <li key={fIndex} className="flex items-center gap-3 text-gray-700 font-medium">
                                                <div className="w-2 h-2 bg-blue-600 rounded-full" />
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="flex-1 w-full">
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        className="rounded-3xl shadow-2xl w-full h-[400px] object-cover hover:scale-[1.02] transition-transform duration-500"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <section className="bg-gray-50 py-24 px-6 text-center border-t border-gray-100">
                    <h2 className="text-4xl font-bold mb-8">Ready to scale with confidence?</h2>
                    <p className="text-xl text-gray-500 mb-12 max-w-2xl mx-auto">
                        Whether you're starting from scratch or optimizing an enterprise app, we have the experience to lead you to success.
                    </p>
                    <a href="/#book-call" className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-5 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all">
                        Schedule an Expert Audit
                    </a>
                </section>

                <Footer />
            </div>
        </div>
    );
}
